import BaseForm from '../base';
import { LatLongColumnsComponent, ObjectPanelComponent, TwoColumnsComponent } from '../components';
export class RadarForm extends BaseForm {
    constructor(...args) {
        super(...args);
        this.components = [
            {
                label: 'Radar Type',
                data: {
                    values: [
                        {
                            label: 'Axis',
                            value: 'axis'
                        },
                    ]
                },
                key: 'type',
                type: 'select',
                defaultValue: 'axis',
                validate: {
                    required: true,
                    onlyAvailableItems: true,
                },
                searchFields: ['label', 'value'],
            },
            new LatLongColumnsComponent({ validate: { required: true } }),
            {
                label: 'Timezone',
                key: 'timezone',
                type: 'select-timezone',
            },
            new TwoColumnsComponent({ key: 'localNetwork' }, {
                label: 'Local IP',
                key: 'ip',
                type: 'textfield',
            }, {
                label: 'Local Port',
                key: 'port',
                type: 'number',
            }),
            new TwoColumnsComponent({ key: 'externalNetwork' }, {
                label: 'External Address',
                key: 'externalIp',
                type: 'textfield',
            }, {
                label: 'External Port',
                key: 'externalPort',
                type: 'number',
            }),
            new TwoColumnsComponent({ key: 'credentials' }, {
                label: 'Username',
                key: 'username',
                type: 'textfield',
            }, {
                label: 'Password',
                key: 'password',
                type: 'customPassword'
            }),
            {
                label: 'Event Grouping Timeout (milliseconds)',
                key: 'debounce',
                type: 'number',
                placeholder: 'e.g., 5000',
                description: 'Time period to group similar events together to reduce event noise.' +
                    ' If a new detection occurs within this time period of a previous detection of the same profile, ' +
                    ' it will be considered a continuation of the previous event rather than a new event.',
            },
            new ObjectPanelComponent({
                key: 'camera',
                label: 'Associated Camera',
                collapsed: false,
                components: [
                    {
                        html: '<div class="help-block">' +
                            'PTZ camera associated with this radar for tracking detected objects.</div>',
                        label: 'Associated Camera Description',
                        refreshOnChange: false,
                        key: 'content',
                        type: 'content',
                        input: false,
                        tableView: false
                    },
                    {
                        key: 'id',
                        label: 'Camera ID',
                        type: 'textfield',
                    }
                ]
            }),
        ];
    }
}
